import React from "react";

// Quiet, typography-only standards strip — compact register, after By the Numbers.
// Apple/Stripe vibe: tight padding, three mono wordmarks, single hairline.
const STANDARDS = [
  { name: "SANS 241",       sub: "SA · Potable Water" },
  { name: "WISA",           sub: "Water Institute of SA" },
  { name: "WHO Guidelines", sub: "International · 4th ed." },
];

export default function TrustStrip() {
  return (
    <section
      className="border-y"
      style={{ background: "#FAFAF7", borderColor: "rgba(12,42,64,0.08)" }}
      data-testid="trust-strip"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-20 py-6 md:py-8">
        <div
          className="grid grid-cols-3 divide-x"
          style={{ borderColor: "rgba(12,42,64,0.10)" }}
        >
          {STANDARDS.map((s) => (
            <div key={s.name} className="px-3 md:px-6 text-center">
              <div
                className="font-display"
                style={{
                  fontSize: "clamp(0.95rem, 1.4vw, 1.2rem)",
                  fontWeight: 600,
                  letterSpacing: "-0.005em",
                  color: "#0C2A40",
                  lineHeight: 1.1,
                }}
              >
                {s.name}
              </div>
              <div
                className="font-mono uppercase mt-1"
                style={{
                  fontSize: "0.54rem",
                  letterSpacing: "0.22em",
                  color: "#5B6877",
                }}
              >
                {s.sub}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
